<template>
  <div class="filtered" v-if="filteredImages">
    <div class="block__header">
      <images-list-toolbar @selectAll="$broadcast('select-item')" :resolutions="filteredImages.AvailableResolutions"></images-list-toolbar>
    </div>
    <div class="block__content" :class="{'invisible': filteredImagesLoading}">
      <ul class="image-list image-list--3">
        <images-list-item v-for="image in filteredImages.Images" track-by="$index" :image="image" :resolutions="image.AvailableResolutions"></images-list-item>
      </ul>
    </div>
    <loading class="filtered-loading" v-if="filteredImagesLoading"></loading>
    <paginator :per-page="[9,12,18,27]" :items-count="filteredImages.ImagesCount" v-on:pagechange="paginatorChanged"></paginator>
  </div>
</template>

<script>
  import ImagesListItem from "../images/ImagesListItem";
  import ImagesListToolbar from "../images/ImagesListToolbar";
  import Paginator from "../../shared/Paginator";
  import Loading from "../../shared/Loading";
  
  import { getFilteredImages } from "./FilterActions";
  import { downloadImages, basketImages, mailImages } from "../images/ImagesActions";

  export default {
    vuex: {
      getters: {
        filteredImages: state => state.filteredImages,
        filteredImagesLoading: state => state.filteredImagesLoading,
        params: state => state.filterParams
      },
      actions: { getFilteredImages, downloadImages, basketImages, mailImages }
    },
    data: function () {
      return {
        selected: []
      };
    },
    components: { ImagesListItem, Paginator, ImagesListToolbar, Loading },
    methods: {
      paginatorChanged (page, itemsPerPage) {
        this.params.pageNumber = page + 1;
        this.params.pageSize = itemsPerPage;
        this.getFilteredImages();
      },
      getSelected () {
        this.selected = [];
        this.$broadcast("get-all-selected");
      }
    },
    events: {
      "return-selected-item": function (item) {
        this.selected.push(item);
      },
      "resolution": function (resolution) {
        this.$broadcast("select-resolution", resolution);
      },
      "download": function () {
        this.getSelected();
        if (this.selected.length) {
          this.downloadImages(this.selected);
        }
      },
      "mail": function () {
        this.getSelected();
        if (this.selected.length) {
          this.mailImages(this.selected);
        }
      },
      "basket": function () {
        this.getSelected();
        if (this.selected.length) {
          this.basketImages(this.selected);
        }
      }
    }
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .filtered{
    width: 740px;
    float: right;
    background: $brown_light;
    position: relative;
  }

  .filtered-loading{
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -19px;
    margin-top: -19px;
  }

  .image-list{
    @include clear-fix;
    @include row(20px);
    list-style: none;
    padding: 0;
  }

  .image-list--3 .image-list__item{
    @include col(20px);
    width: 33.33%;

    .image-container{
      max-width: 198px;
      height: 164px;
    }
  }

  .block__content.invisible{
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// FilterImagesList.vue?352a18f1